import geoRepository from '../repositories/geoRepository'

export default function isGeo(geo: string) {
  return geoRepository() === geo
}
